import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch, store } from "../../../../utils/httpUtil";
import { message } from "antd";

export const searchUserWithCriteria = createAsyncThunk(
  "user/search",
  async (payload) => {
    try {
      const response = await store("v1/users/search", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const addUser = createAsyncThunk("user/add", async (payload) => {
  try {
    const response = await store("v1/users", payload);
    return response?.data?.data;
  } catch (error) {
    message.error(error?.response?.data?.message);
    throw error;
  }
});

export const findUserByIdentifier = createAsyncThunk(
  "user/detail",
  async (id) => {
    try {
      const response = await fetch(`v1/users/${id}/detail`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateUsers = createAsyncThunk("update/users", async (payload) => {
  try {
    const response = await store(`v1/users/${payload?.id}/update`, payload);
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
});

export const fetchUpdateRequest = createAsyncThunk(
  "users/update-request",
  async (id) => {
    try {
      const response = await fetch(`v1/users/${id}/update-request`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

const listPending = ["user/search/pending"];
const listFulfilled = ["user/search/fulfilled"];
const listRejected = ["user/search/rejected"];

const detailPending = [
  "user/add/pending",
  "user/detail/pending",
  "update/users/pending",
  "users/update-request/pending",
];
const detailFulfilled = [
  "user/add/fulfilled",
  "user/detail/fulfilled",
  "update/users/fulfilled",
  "users/update-request/fulfilled",
];
const detailRejected = [
  "user/add/rejected",
  "user/detail/rejected",
  "update/users/rejected",
  "users/update-request/rejected",
];

export const usersSlice = createSlice({
  name: "users",
  initialState: {
    usersPayload: [],
    usersLoading: false,
    usersPagination: {},
    usersErrors: {},

    usersDetailPayload: [],
    usersDetailLoading: false,
    usersDetailErrors: {},
  },
  reducers: {
    cleanUsers(state) {
      state.usersPayload = [];
      state.usersLoading = false;
      state.usersPagination = {};
      state.usersErrors = {};
    },
    cleanUsersDetail(state) {
      state.usersDetailPayload = [];
      state.usersDetailLoading = false;
      state.usersDetailErrors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => listPending.includes(action.type),
        (state) => {
          state.usersLoading = true;
        }
      )
      .addMatcher(
        (action) => listFulfilled.includes(action.type),
        (state, action) => {
          state.usersLoading = false;
          state.usersPayload = action.payload.data;
          state.usersPagination = action.payload.pagination?.[0];
        }
      )
      .addMatcher(
        (action) => listRejected.includes(action.type),
        (state, action) => {
          state.usersLoading = false;
          state.usersErrors = action.error;
        }
      )
      .addMatcher(
        (action) => detailPending.includes(action.type),
        (state) => {
          state.usersDetailLoading = true;
        }
      )
      .addMatcher(
        (action) => detailFulfilled.includes(action.type),
        (state, action) => {
          state.usersDetailLoading = false;
          state.usersDetailPayload = action.payload.data;
        }
      )
      .addMatcher(
        (action) => detailRejected.includes(action.type),
        (state, action) => {
          state.usersDetailLoading = false;
          state.usersDetailErrors = action.error;
        }
      );
  },
});

export const { cleanUsers, cleanUsersDetail } = usersSlice.actions;
